import { ceiba_serverService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, ceiba_servers: [], ceiba_server: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        ceiba_serverService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        ceiba_serverService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/ceiba_servers');
                    dispatch('alert/success', "Ceiba Server Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/ceiba_servers');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        ceiba_serverService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/ceiba_servers');
                    dispatch('alert/success', "Ceiba Server Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/ceiba_servers');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        ceiba_serverService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      ceiba_serverService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/ceiba_servers');
                  dispatch('alert/success', "Ceiba Server Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/ceiba_servers');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  ceiba_servers: state => {
    return state.ceiba_servers
  },
  ceiba_server: state => {
    return state.ceiba_server
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.ceiba_server = {};
        state.ceiba_servers = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.ceiba_server = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.ceiba_servers = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const ceiba_servers = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
